import { FC, Fragment, useMemo } from 'react';
import { useLocation, Outlet } from 'react-router-dom';

import { useAtomValue } from 'jotai';

import { GlobalPopover } from '@shared/components';

import { Header } from './header/Header';
import { SideBar } from './sideBar/SideBar';

import css from './AppLayout.module.css';

import { geoAtom } from 'v2/atoms/geoAtom';
import { GeoContextBadge } from 'v2/components/geoContextBadge/GeoContextBadge';
import { AuthLoader } from 'v2/components/loader/authLoader/AuthLoader';
import { Geo } from 'v2/constants';
import { useCheckAuth } from 'v2/hooks/api/useCheckAuth';
import { AppRoute } from 'v2/routes';

export const AppLayout: FC = () => {
  const location = useLocation();
  const geo = useAtomValue(geoAtom);

  const isAuthChecking = useCheckAuth();

  const isNoInterfacePage = useMemo(
    () => [AppRoute.LOGIN_PAGE, AppRoute.FORBIDDEN].includes(location.pathname as AppRoute),
    [location.pathname]
  );

  return (
    <main className={`${css.appLayout} ${geo === Geo.KZ ? css.appLayoutKz : ''}`}>
      {isAuthChecking ? (
        <AuthLoader />
      ) : (
        <Fragment>
          {!isNoInterfacePage && <Header />}
          {!isNoInterfacePage && <GeoContextBadge />}

          <div className={css.appLayoutBody}>
            {!isNoInterfacePage && <SideBar />}

            <Outlet />
          </div>

          {/*TODO upd*/}
          <GlobalPopover />
        </Fragment>
      )}
    </main>
  );
};
